import React from 'react';
import PropTypes from 'prop-types';

export default function AgGridContainer({ numberOfRow, children, ...props }) {
  numberOfRow = Math.min(10, numberOfRow);
  numberOfRow = Math.max(1, numberOfRow);
  return (
    <div {...props} style={{ height: `${100 + numberOfRow * 42}px` }}>
      {children}
    </div>
  );
}

AgGridContainer.propTypes = {
  numberOfRow: PropTypes.number.isRequired,
  children: PropTypes.element.isRequired,
};
